import { useMemo } from 'react';
import { useQuery } from '@apollo/client/react';
import { format, parseISO } from 'date-fns';
import { NOTIFICATIONS_QUERY } from '../graphql/queries';
import type { NotificationsQueryData } from '../types';
import { Panel } from './panel';

/** Current notices from Hi-Level. */
export function NoticesPanel() {
  const today = useMemo(() => new Date().toISOString(), []);
  const { data, loading, error } = useQuery<NotificationsQueryData>(NOTIFICATIONS_QUERY, {
    variables: { today },
    fetchPolicy: 'cache-and-network',
  });

  const notices = data?.notifications ?? [];

  return (
    <Panel
      title="From Hi-Level"
      subtitle={notices.length ? `${notices.length} current` : undefined}
      action={{ label: 'All notices', to: '/notifications' }}
      loading={loading && notices.length === 0}
      error={error}
      empty={notices.length === 0 && !loading ? 'Nothing posted.' : undefined}
    >
      <div className="divide-y divide-hilevel-border">
        {notices.slice(0, 4).map((notice, index) => (
          <div key={`${notice.subject}-${index}`} className="py-2 first:pt-0">
            <p className="text-sm font-medium text-hilevel-slate m-0">{notice.subject}</p>
            {notice.description && (
              <p className="text-xs text-hilevel-gray m-0 mt-0.5 line-clamp-2">
                {notice.description}
              </p>
            )}
            {notice.updatedAt && (
              <p className="text-[11px] text-hilevel-gray m-0 mt-1">
                {format(parseISO(notice.updatedAt), 'd MMM yyyy')}
              </p>
            )}
          </div>
        ))}
      </div>
    </Panel>
  );
}
